import memoizeOne from 'memoize-one';
import { getIssueTypesById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issue-types';
import {
	getSelectedIssues,
	getAllSortedIssues,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/issues';
import { getProjectsById } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/projects';
import { getAncestors } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/timeline-preview';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { functionWithFFRedux } from '@atlassian/jira-react-redux';

const mapStateToPropsOld = (state: State) => ({
	allSortedIssues: getAllSortedIssues(state),
	getAncestors: (issueId: string) => getAncestors(state, { issueId }),
	issueTypesById: getIssueTypesById(state),
	projectsById: getProjectsById(state),
	selectedIssues: getSelectedIssues(state),
});

const mapStateToPropsFactory = () => {
	const getAncestorsFactory = memoizeOne(
		(state: State) => (issueId: string) => getAncestors(state, { issueId }),
	);
	return (state: State) => ({
		allSortedIssues: getAllSortedIssues(state),
		getAncestors: getAncestorsFactory(state),
		issueTypesById: getIssueTypesById(state),
		projectsById: getProjectsById(state),
		selectedIssues: getSelectedIssues(state),
	});
};

// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
const mapStateToProps = functionWithFFRedux(mapStateToPropsFactory, mapStateToPropsOld);
export default mapStateToProps;
